module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-06-24 at 3.46.33 PM.b2227f92.jpeg";